export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/dutch.05afdee.svg";